import React from 'react';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import ListItemButton from '@mui/material/ListItemButton';
import { faCirclePlus } from '@fortawesome/pro-duotone-svg-icons/faCirclePlus';

import { COURSE } from 'common/dattrs';
import BongoFontAwesomeIcon from 'components/common/icon/BongoFontAwesomeIcon';
import CourseAddDialog from 'components/course/CourseAddDialog';
import CourseService from 'service/course';
import { getCourseFilters, getCourseFilterFieldValue, getRawCourses } from 'redux/course/course.selectors';
import { getCurrentOrg } from 'redux/org/org.selectors';
import Permissions from 'common/utils/permissions';

import CourseListItem from './CourseListItem';
import CourseListOption from './CourseListOptions';
import styles from './CourseList.module.scss';
function CourseList(props) {
  const { courses } = props;
  const filters = useSelector(getCourseFilters);
  const filterValue = useSelector(getCourseFilterFieldValue);
  const org = useSelector(getCurrentOrg);
  const rawCourses = useSelector(getRawCourses);
  const [createDialogVisible, setCreateDialogVisible] = React.useState(false);

  function isListFiltered() {
    let count = filters.role.length + filters.autoEnrollment.length;
    if (!_.isEmpty(filterValue)) {
      count++;
    }

    return count > 0;
  }

  async function onCreateCourse(name) {
    try {
      setCreateDialogVisible(false);
      // setLoaderVisible(true);
      // TODO we are only allowing creating for the first org that we find
      await CourseService.createCourse(name, org.id);
      // setLoaderVisible(false);
    } catch (err) {
      console.error(`Error creating course '${name}':`, err);
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.filterContainer}>
        <CourseListOption />
      </div>

      <div className={styles.createContainer}>
        {Permissions.isCourseCreateVisible(rawCourses) ? (
          <ListItemButton
            {...COURSE.create}
            aria-label={t`Create Course`}
            component='a'
            onClick={() => {
              setCreateDialogVisible(true);
            }}
            className={styles.createButton}
          >
            <BongoFontAwesomeIcon
              className={styles.addIcon}
              icon={faCirclePlus}
              size={28}
              style={{ '--fa-primary-color': '#000', '--fa-secondary-color': '#888' }}
            />
            <span className={styles.name}>{t`Create Course`}</span>
          </ListItemButton>
        ) : (
          <div className={styles.separator}></div>
        )}
      </div>

      <div {...COURSE.list.items} role='list' className={styles.courseList}>
        {isListFiltered() && courses.length === 0 && (
          <div className={styles.emptyCourseList}>
            <span>{t`No courses found`}</span>
          </div>
        )}
        {_.map(courses, (course) => {
          return <CourseListItem key={`courseListItem[${course.id}]`} className={styles.listItem} course={course} />;
        })}
      </div>

      {createDialogVisible && (
        <CourseAddDialog onCancel={() => setCreateDialogVisible(false)} onCreate={onCreateCourse} />
      )}
    </div>
  );
}

CourseList.propTypes = {
  courses: PropTypes.array,
};

CourseList.defaultProps = {
  courses: [],
};

export default CourseList;
